import BaseError from '@/modules/shared/exceptions/BaseError'

export default class FailedMultipartUploadException extends BaseError {
  constructor(info: { message: string; action: string }) {
    super({
      name: 'FailedMultipartUploadException',
      action: info.action,
      message: info.message
    })
  }
}
